import { render } from "./PasswordRecovery.vue?vue&type=template&id=119a8481"
import script from "./PasswordRecovery.vue?vue&type=script&lang=js"
export * from "./PasswordRecovery.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__